// NOTE: This component embeds a legacy React 16 app.
// Do not upgrade React dependencies without refactoring DialogFeed.
import * as React from "react";
import * as ReactDOM from "react-dom";
import * as uuid from "uuid";
import * as invariant from "invariant";

import DialogFeed from "./dialog-feed";

import {
  Component,
  OnInit,
  AfterViewInit,
  OnDestroy,
  OnChanges,
} from "@angular/core";

import { UserService } from "./../shared/services/user.service";

import { AppSettingsService } from "./../shared/services/app-settings.service";

import "core-js/es6/map";
import "core-js/es6/set";
import { Router } from "@angular/router";

interface DialogProps {
  name: string;
  externalId: string;
  email: string;
  serviceUrl: string;
  hubPath: string;
  appKey: string;
  appSecret: string;
  hero: boolean;
  enableMessageSnippets: boolean;
}

@Component({
  selector: "app-message-center",
  template: '<span [id]="rootDomID"></span>',
})
export class MessageCenterComponent
  implements OnInit, OnDestroy, OnChanges, AfterViewInit
{
  constructor(
    private userService: UserService,
    private appSettings: AppSettingsService,
    private router: Router
  ) {}

  public rootDomID: string;

  protected getRootDomNode() {
    const node = document.getElementById(this.rootDomID);
    invariant(node, `Node '${this.rootDomID} not found!`);
    return node;
  }

  protected getProps(): DialogProps {
    return {
      name:
        this.userService.CurrentUser.firstName +
        " " +
        this.userService.CurrentUser.lastName,
      externalId: this.userService.CurrentUser.personId,
      email: this.userService.CurrentUser.email,
      serviceUrl: this.appSettings.MessageCenterBaseUrl,
      hubPath: "/signalr",
      appKey: this.appSettings.MessageCenterAppKey,
      appSecret: this.appSettings.MessageCenterAppSecret,
      hero: true,
      enableMessageSnippets: true,
    };
  }

  private isMounted(): boolean {
    return !!this.rootDomID;
  }

  protected render() {
    try {
      if (
        !this.userService.CurrentUser ||
        !this.userService.CurrentUser.personId
      ) {
        throw new Error(
          "Invalid user - possibly due to an expired/invalid cert"
        );
      }

      if (this.isMounted()) {
        ReactDOM.render(
          React.createElement(DialogFeed, this.getProps()),
          this.getRootDomNode()
        );
      }
    } catch (error) {
      console.error("Message Center failed to load:", error);
      this.router.navigate(["/"]); // Redirect to home
    }
  }

  ngOnInit() {
    this.rootDomID = uuid.v1();
  }

  ngOnChanges() {
    this.render();
  }

  ngAfterViewInit() {
    this.render();
  }

  ngOnDestroy() {
    ReactDOM.unmountComponentAtNode(this.getRootDomNode());
  }
}
